import script from "./ModalEditOrganizationInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEditOrganizationInfo.vue?vue&type=script&setup=true&lang=js"

import "./ModalEditOrganizationInfo.vue?vue&type=style&index=0&id=136f4b84&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-136f4b84"]])

export default __exports__